/* eslint-disable no-param-reassign */
import { createStore } from 'vuex';
import { fetchStatic, flatData, FETCH_LIST, fetchStaticStone } from '@/hooks/hookUtils';
import mockData from '../../mock_data.json';

// 接入云歌后 考虑是否要分module
export default createStore({
  state() {
    return {
      data: mockData,
      fetched: {
        infomation: false,
        home: false,
        about: false,
        newslist: false,
        useragreement: false,
      },
      home: {
        banner: mockData.home_banner,
        projectsList: mockData.projectList,
        foundation: mockData.about,
        newsList: mockData.newslist,
        link: mockData.declare_link,
      },
      stone: {
        expert: mockData.expert,
        awardeeInfo: mockData.awardeeInfo,
        researcher_list: mockData.researcher_list,
        dynamics_list: mockData.dynamics_list,
      },
      xp: {
        expert: mockData.expert_xp,
        awardeeInfo: mockData.awardeeInfo_xp,
        researcher_list: mockData.researcher_list_xp,
        dynamics_list: mockData.dynamics_list_xp,
      },
    };
  },
  getters: {},
  mutations: {
    setData(state, value) {
      state.data = value;
    },
    toggleFetched(state, { key, value }) {
      state.fetched[key] = value;
    },
    setInfomation(state, value) {
      state.data.infomation = value;
    },
    setAbout(state, value) {
      state.data.about = value;
    },
    setNewsList(state, value) {
      state.data.newsList = value;
    },
    setUserAgreement(state, value) {
      state.data.userAgreementData = value;
    },
    setHome(state, value) {
      state.home = value;
    },
    setStone(state, value) {
      state.stone = value;
    },
    setXp(state, value) {
      state.xp = value;
    },
  },
  actions: {
    async fetchInfomation({ commit }) {
      try {
        const result = await fetchStatic(FETCH_LIST.INFOMATION);
        const { infomation } = flatData(result);
        commit('setInfomation', infomation);
        commit('toggleFetched', { key: 'infomation', value: true });
      } catch (e) {
        commit('setInfomation', mockData.infomation);
        commit('toggleFetched', { key: 'infomation', value: false });
      }
    },
    async fetchAbout({ commit }) {
      const result = await fetchStatic(FETCH_LIST.ABOUT);
      const about = flatData(result);
      commit('setAbout', about);
      commit('toggleFetched', { key: 'about', value: true });
    },
    async fetchNewsList({ commit }) {
      const result = await fetchStatic(FETCH_LIST.NEWLISTS);
      const { newsList } = flatData(result);
      commit('setNewsList', newsList);
      commit('toggleFetched', { key: 'newslist', value: true });
    },
    async fetchUserAgreement({ commit }) {
      const result = await fetchStatic(FETCH_LIST.USERAGREEMENT);
      const {
        useragreement: { userAgreement, userAgreementEn },
      } = flatData(result);
      const data = {
        userAgreement,
        userAgreementEn,
      };
      commit('setUserAgreement', data);
      commit('toggleFetched', { key: 'useragreement', value: true });
    },
    async fetchHome({ commit }) {
      const result = await fetchStatic(FETCH_LIST.HOME, true);
      const home = flatData(result);
      const stoneLink = await fetchStaticStone('home_config', true);
      home.stoneLink = stoneLink;
      home.banner = result.banner;
      home.link = result.declare_link;
      commit('setHome', home);
      commit('toggleFetched', { key: 'home', value: true });
    },
    async fetchStone({ commit }) {
      const result = await fetchStatic(FETCH_LIST.NEWCORNERSTONE, true);
      const stone = flatData(result);
      commit('setStone', stone);
      commit('toggleFetched', { key: 'stone', value: true });
    },
    async fetchXp({ commit }) {
      const result = await fetchStatic(FETCH_LIST.XPLORERPRIZE, true);
      const xp = flatData(result);
      commit('setXp', xp);
      commit('toggleFetched', { key: 'xp', value: true });
    },
  },
  modules: {},
});
